import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../api/client';
import { useTranslation } from 'react-i18next';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiClient.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setError(t('auth.forgotError', 'Fehler beim Senden. Bitte versuche es erneut.'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4">
      <div className="w-full max-w-md">
        <div className="card">
          <h1 className="text-2xl font-bold text-gray-900 mb-1">
            {t('auth.forgotTitle', 'Passwort vergessen')}
          </h1>

          {sent ? (
            <div className="mt-4">
              <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-4 rounded-lg text-sm">
                <p className="font-medium mb-1">{t('auth.forgotSentTitle', 'E-Mail gesendet')}</p>
                <p>{t('auth.forgotSentText', 'Falls ein Konto mit dieser Adresse existiert, erhältst du in Kürze einen Reset-Link.')}</p>
              </div>
              <Link to="/login" className="btn btn-secondary w-full mt-4 text-center">
                {t('auth.backToLogin', 'Zurück zur Anmeldung')}
              </Link>
            </div>
          ) : (
            <>
              <p className="text-gray-500 text-sm mt-1 mb-6">
                {t('auth.forgotSubtitle', 'Gib deine E-Mail-Adresse ein und wir schicken dir einen Link zum Zurücksetzen.')}
              </p>
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm mb-4">
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="label">{t('auth.email')}</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input"
                    placeholder={t('auth.emailPlaceholder')}
                    required
                    autoFocus
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading || !email}
                  className="btn btn-primary w-full"
                >
                  {loading ? t('auth.sending', 'Wird gesendet…') : t('auth.forgotButton', 'Reset-Link senden')}
                </button>
              </form>
              <div className="mt-4 text-center">
                <Link to="/login" className="text-sm text-primary-600 hover:text-primary-700">
                  {t('auth.backToLogin', 'Zurück zur Anmeldung')}
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
